var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquilateralUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 70,
    viewBox: "0 0 80 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6699 2.5C37.5944 -0.833332 42.4056 -0.833334 44.3301 2.5L78.9711 62.5C80.8956 65.8333 78.49 70 74.641 70H5.35899C1.50998 70 -0.895644 65.8333 1.02886 62.5L35.6699 2.5Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquilateralUp);
export default __webpack_public_path__ + "static/media/Equilateral_Up.091da94c4526a96cc7881a0e28af613e.svg";
export { ForwardRef as ReactComponent };